import React from 'react';

const formatDate = (dateInput, isDateOnly = false) => {
    if (!dateInput) return "";
    try {
        const date = new Date(dateInput);
        const pad = (n) => n.toString().padStart(2, '0');
        const mm = pad(date.getMonth() + 1);
        const dd = pad(date.getDate());
        const yyyy = date.getFullYear();
        const formattedDate = `${mm}/${dd}/${yyyy}`;

        if (isDateOnly) return formattedDate;

        const hours = date.getHours();
        const minutes = pad(date.getMinutes());
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const displayHours = hours % 12 || 12;

        return `${formattedDate} ${displayHours}:${minutes} ${ampm}`;
    } catch (error) {
        console.error("Invalid date format:", dateInput, error);
        return "";
    }
};

const RenderFields = ({ fields, formData }) => {
    return fields?.map((field) => {
        if (field.condition && !field.condition.values.includes(formData[field.condition.key])) {
            return null;
        }

        let displayValue = '-';

        // Handle subKeys (nested object fields)
        if (field.subKeys && Array.isArray(field.subKeys)) {
            const parent = formData[field.key] || {};
            displayValue = field.subKeys
                .map(subKey => parent[subKey])
                .filter(Boolean)
                .join(" ") || '-';
        }

        // Handle select/options type
        else if (field.options && Array.isArray(field.options)) {
            const matchedOption = field.options.find(opt => opt.key === formData[field.key]);
            displayValue = matchedOption?.label || formData[field.key] || '-';
        }

        // Handle datetime-local
        else if (field.type === 'datetime-local') {
            displayValue = formatDate(formData[field.key], field.isDateOnly);
        }

        // Fallback to raw value
        else {
            displayValue = formData[field.key] ?? '-';
        }

        return (
            <div key={field.key} className="flex flex-col w-full">
                <div className="flex items-center w-full pb-0">
                    <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                        {field.label}
                    </label>
                    {field.type === 'checkbox' ? (
                        <input
                            type="checkbox"
                            checked={!!formData[field.key]}
                            disabled
                            className="cursor-not-allowed w-5 h-5"
                        />
                    ) : (
                        <p className="h-10 px-4 flex items-center border border-gray-300 bg-gray-100 flex-grow">
                            {displayValue}
                        </p>
                    )}
                </div>
            </div>
        );
    });
};

export { RenderFields };